// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SearchResults":"jh_a bii_a bii_j bii_q bii_sv bii_sw bii_w"};